import { AxiosError, AxiosResponse } from 'axios'

import { axiosServer as axios } from '@/base/axios'

export const getPromiseFromFetch = <T = any>({
  params = {},
  config = {},
  method = 'get',
  url = ''
}) =>
  new Promise<AxiosResponse<T>>((resolve) =>
    (axios as any)
      [method](url, params, config)
      .then(resolve)
      // no response at all (DNS, timeout, CORS): resolve a status-0 stub so callers can destructure
      .catch((error: AxiosError) =>
        resolve(error.response ?? ({ status: 0, data: undefined } as AxiosResponse))
      )
  )
